module.exports = __webpack_public_path__ + "img/inco3.75caefb5.png";